import { useLazyQuery } from "@apollo/client/react";import { FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { CustomButton } from '../../../components/customButton/CustomButton';
import SearchIcon from '@mui/icons-material/Search';

import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import { GET_JUSTIFICAR_MINUTA_GRILLA, adaptJustificarMinutaGrillaArray } from '../../../data/graphQL/queries/JustificarMinuta/getJustificacionMinutaGrilla';

export const JustificarMinutaGrillaFilters = ({
  delegaciones,
  filters,
  handleChangeFilters,
  setJustificacionesGrilla,
  setJustificacionesGrillaLoading,
  setDelegaciones,
  refetchGrilla,
  setRefetchGrilla,
  generateRunning
}) => {
  const storageId = sessionStorage.getItem('idUsuario');
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);
  const [datosOriginal, setDatosOriginal] = useState([]);
  const [textFilter, setTextFilter] = useState(null);
  const txtFiltro = useRef(null);

  useEffect(() => {
    if (!delegacionesLoading)
    getDelegaciones({variables: { idUsuario: JSON.parse(storageId, 10) }});
    if (localStorage.getItem('justificarMinutaGrillaFilters') != null && !getJustificacionesGrillaLoading)
    handleSearch();
  }, []);

  const [getDelegaciones, { data: delegacionesData, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!delegacionesData) return;
    setDelegaciones(adaptDelegacionArray(delegacionesData));
	}, [delegacionesData]);

  useEffect(() => {
    if (delegaciones != null && !delegacionOrigenLoading)
    getDelegacionOrigen({variables: { idUsuario: JSON.parse(storageId, 10) }});
  }, [delegaciones]);

  const [getDelegacionOrigen, { data: delegacionOrigenData, loading: delegacionOrigenLoading }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!delegacionOrigenData) return;
    if (delegacionOrigenData.usuarioFull.success) {
      const deleg = parseInt(delegacionOrigenData.usuarioFull.valorEsperado.delegacionOrigen, 10);
      setDelegacionOrigen(deleg);
      handleChangeFilters('idDelegacion', localStorage.getItem('generarMinutaGrillaFilters') != null && filters.idDelegacion > 0 ? filters.idDelegacion : deleg);
    }
	}, [delegacionOrigenData]);

  useEffect(() => {
    if (refetchGrilla && !getJustificacionesGrillaLoading)
    handleSearch();
  }, [refetchGrilla]);

  const [getJustificacionesGrilla, { data: dataJustificacionesGrilla, loading: getJustificacionesGrillaLoading }] = useLazyQuery(GET_JUSTIFICAR_MINUTA_GRILLA, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!dataJustificacionesGrilla) return;
    setJustificacionesGrillaLoading(false);
    const regs = adaptJustificarMinutaGrillaArray(dataJustificacionesGrilla.listarJustificaciones);
    setDatosOriginal(regs);
    setJustificacionesGrilla(regs);
    setRefetchGrilla(false);
	}, [dataJustificacionesGrilla]);

  const handleSearch = () => {
    if (!getJustificacionesGrillaLoading) {
      // limpio la grilla
      setDatosOriginal([]);
      setJustificacionesGrilla([]);

      setJustificacionesGrillaLoading(true);
      getJustificacionesGrilla({ variables: { idDelegacion: filters.idDelegacion } });
    }
  };

  const handleTextFilter = () => {
    const inputBuscar = textFilter?.toString().toUpperCase();

    if (inputBuscar?.length >= 2) {
      setJustificacionesGrilla(datosOriginal?.filter((datoOriginal) => {
        const pendienteBuscar = datoOriginal.idPendiente.toString();
        const contratoBuscar = datoOriginal.idEvaluacion.toString();
        const hcBuscar = datoOriginal.idPaciente.toString();
        const nombrePacienteBuscar = datoOriginal.paciente.toUpperCase();
        const clienteBuscar = datoOriginal.cliente.toUpperCase();
        const clienteSapBuscar = datoOriginal.codClienteSAP.toString();
        const moduloBuscar = datoOriginal.modulo.toUpperCase();

        return (
          pendienteBuscar.includes(inputBuscar) ||
          contratoBuscar.includes(inputBuscar) ||
          hcBuscar.includes(inputBuscar) ||
          nombrePacienteBuscar.includes(inputBuscar) ||
          clienteBuscar.includes(inputBuscar) ||
          clienteSapBuscar.includes(inputBuscar) ||
          moduloBuscar.includes(inputBuscar));

      }));
    } else {
      setJustificacionesGrilla(datosOriginal);
    }
  };

  return (
    <>
            <Grid container spacing={2}>                
                <Grid size={{ md: 2.5 }}>
                    <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                        <InputLabel id="select-delegacion">Delegación</InputLabel>
                        <Select
              labelId="select-delegacion"
              options={delegaciones}
              label='Delegación'
              onChange={(e) => {
                handleChangeFilters('idDelegacion', e.target.value);
              }}
              value={filters?.idDelegacion}
              name='idDelegacion'>
              
                            {delegaciones && delegaciones.map((delegacion) => {
                return delegacion.id > 0 && <MenuItem key={delegacion.id} value={delegacion.id}> {delegacion.displayName} </MenuItem>;
              })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ md: 2.7 }}>
                    <TextField
            label="Filtrar"
            name="txtFiltro"
            size="small"
            type="text"
            variant="outlined"
            value={textFilter ?? ''}
            onChange={(e) => setTextFilter(e.target.value)}
            onKeyUp={handleTextFilter}
            sx={{ backgroundColor: 'white' }}
            InputProps={{
              endAdornment:
              <InputAdornment position="end">
                                    <SearchIcon
                  onClick={handleTextFilter}
                  sx={{ cursor: 'pointer' }} />
                
                                </InputAdornment>

            }} />
          
                </Grid>
                <Grid size={{ md: 1.2 }} sx={{ textAlign: 'right' }}>
                    <CustomButton
            variant='contained'
            className='margin-right'
            onClick={handleSearch}
            size='small'
            isLoading={getJustificacionesGrillaLoading}
            disabled={generateRunning}>
            
                        Buscar
                    </CustomButton>
                </Grid>
            </Grid>
        </>);

};